import React,{useState, useEffect} from 'react';

const Header = () => {
   return <>
      <h1 className="header">expense tracker</h1>
   </>;
}

export default Header;